import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// ✅ Pages
import Login from "./views/pages/Login";
import Home from "./views/pages/Home";
import NotFoundPage from "./views/pages/404";

// 📦 Reports
import Reports from "./views/pages/Reports";
import SalesReport from "./views/pages/Reports/SalesReport";
import InventoryMovementReport from "./views/pages/Reports/InventoryMovementReport";
import StockBalanceReport from "./views/pages/Reports/StockBalanceReport";
import LoanCrateReport from "./views/pages/Reports/LoanCrateReport";
import DepositReport from "./views/pages/Reports/DepositReport";
import OverdueLoanCrateReport from "./views/pages/Reports/OverdueLoanCrateReport";
import ReceivablesReport from "./views/pages/Reports/ReceivablesReport";
import PayablesReport from "./views/pages/Reports/PayablesReport";
import VansaleReport from "./views/pages/Reports/VansaleReport";

// 📦 Purchase
import PurchaseRequest from "./views/pages/Purchase/PurchaseRequest";
import ProductReceipt from "./views/pages/Purchase/ProductReceipt";
import PaymentVoucher from "./views/pages/Purchase/PaymentVoucher";

// 📦 Warehouse
import WarehouseStock from "./views/pages/Warehouse/WarehouseStock";
import TreasuryDocuments from "./views/pages/Warehouse/TreasuryDocuments";
import Icebox from "./views/pages/Warehouse/Icebox";
import TechnicalEquipForm from "./views/pages/Warehouse/TechnicalEquipForm";
import OfficeEquipForm from "./views/pages/Warehouse/OfficeEquipForm";

// 📦 Sell Products
import Quotation from "./views/pages/SellProducts/Quotation";
import CreditNote from "./views/pages/SellProducts/CreditNote";
import DR from "./views/pages/SellProducts/DR";

// 📦 Accounting
import PaymentStock from "./views/pages/Account/PaymentStock";
import Bill from "./views/pages/Account/Bill";
import Invoice from "./views/pages/Account/Invoice";
import Receipt from "./views/pages/Account/Receipt";
import ReceiptVoucher from "./views/pages/Account/ReceiptVoucher";
import Tax from "./views/pages/Account/Tax";

// 📦 Initial Data
import Creditor from "./views/pages/InitialData/Creditor";
import TbSetAPType from "./views/pages/InitialData/TbSetAPType";
import Debtor from "./views/pages/InitialData/Debtor";
import TbSetARType from "./views/pages/InitialData/TbSetARType";
import Company from "./views/pages/InitialData/Company";
import Dept from "./views/pages/InitialData/TbSetDept";
import Position from "./views/pages/InitialData/TbSetPosition";
import Employee from "./views/pages/InitialData/Employee";
import TbSetItem from "./views/pages/InitialData/TbSetItem";
import TbSetItmBrand from "./views/pages/InitialData/TbSetItmBrand";
import TbSetUnit from "./views/pages/InitialData/TbSetUnit";
import TbSetWh from "./views/pages/InitialData/TbSetWH";

// 📦 CRM
import SalesReportCustomer from "./views/pages/CustomerRelationshipManagement/SalesReportCustomer";
import PurchaseReport from "./views/pages/CustomerRelationshipManagement/PurchaseReport";
import DebtorReport from "./views/pages/CustomerRelationshipManagement/DebtorReport";
import InvoiceReport from "./views/pages/CustomerRelationshipManagement/InvoiceReport";
import TopBuyingProductsReport from "./views/pages/CustomerRelationshipManagement/TopBuyingProducts";
import TopSellingProductsReport from "./views/pages/CustomerRelationshipManagement/TopSellingProducts";
import InactiveCustomersReport from "./views/pages/CustomerRelationshipManagement/InactiveCustomersReport";
import JobAssignmentSystem from "./views/pages/CustomerRelationshipManagement/JobAssignmentSystem";
import JobAssignmentSystemForm from "./views/pages/CustomerRelationshipManagement/JobAssignmentSystemComponents/JobForm";

// 📦 Service
import JobDetail from "./views/pages/Job/Detail";

// ✅ Get auth and company
const isLoggedIn = localStorage.getItem("token");
const company = localStorage.getItem("company");

// ✅ Route config array
const routesConfig = [
  // Public routes
  { path: "/", element: <Home />, protected: true },
  { path: "/login", element: <Login /> },
  { path: "/reports", element: <Reports />, protected: true },
  { path: "/sales-report", element: <SalesReport />, protected: true },
  { path: "/inventory-movement-report", element: <InventoryMovementReport />, protected: true },
  { path: "/stock-balance-report", element: <StockBalanceReport />, protected: true },
  { path: "/loan-crate-report", element: <LoanCrateReport />, protected: true },
  { path: "/deposit-report", element: <DepositReport />, protected: true },
  { path: "/overdue-loan-crate-report", element: <OverdueLoanCrateReport />, protected: true },
  { path: "/receivables-report", element: <ReceivablesReport />, protected: true },
  { path: "/payables-report", element: <PayablesReport />, protected: true },
  { path: "/vansale-report", element: <VansaleReport />, protected: true },

  // Purchase
  { path: "/purchase-request", element: <PurchaseRequest />, protected: true },
  { path: "/product-receipt", element: <ProductReceipt />, protected: true },
  { path: "/payment-voucher", element: <PaymentVoucher />, protected: true },

  // Warehouse
  { path: "/warehouse-stock", element: <WarehouseStock />, protected: true },
  { path: "/treasury-documents", element: <TreasuryDocuments />, protected: true },

  // Warehouse
  { path: "/icebox", element: <Icebox />, protected: true, onlyForCompany: "2" },
  { path: "/technical-equip-form", element: <TechnicalEquipForm />, protected: true },
  { path: "/office-equip-form", element: <OfficeEquipForm />, protected: true },

  // Sell Products
  { path: "/quotation", element: <Quotation />, protected: true },
  { path: "/credit-note", element: <CreditNote />, protected: true },
  { path: "/debit-note", element: <DR />, protected: true },

  // Accounting
  { path: "/payment-stock", element: <PaymentStock />, protected: true },
  { path: "/bill", element: <Bill />, protected: true },
  { path: "/invoice", element: <Invoice />, protected: true },
  { path: "/receipt", element: <Receipt />, protected: true },
  { path: "/receipt-voucher", element: <ReceiptVoucher />, protected: true },
  { path: "/tax", element: <Tax />, protected: true },

  // Initial Data
  { path: "/creditor", element: <Creditor />, protected: true },
  { path: "/APtype", element: <TbSetAPType />, protected: true },
  { path: "/debtor", element: <Debtor />, protected: true },
  { path: "/ARtype", element: <TbSetARType />, protected: true },
  { path: "/company", element: <Company />, protected: true },
  { path: "/dept", element: <Dept />, protected: true },
  { path: "/position", element: <Position />, protected: true },
  { path: "/employee", element: <Employee />, protected: true },
  { path: "/tbsetitem", element: <TbSetItem />, protected: true },
  { path: "/brand", element: <TbSetItmBrand />, protected: true },
  { path: "/tb-set-unit", element: <TbSetUnit />, protected: true },
  { path: "/tb-set-wh", element: <TbSetWh />, protected: true },

  // CRM
  { path: "/sales-report-customer", element: <SalesReportCustomer />, protected: true },
  { path: "/purchase-report", element: <PurchaseReport />, protected: true },
  { path: "/debtor-report", element: <DebtorReport />, protected: true },
  { path: "/invoice-report", element: <InvoiceReport />, protected: true },
  { path: "/top-buying-products", element: <TopBuyingProductsReport />, protected: true },
  { path: "/top-selling-products", element: <TopSellingProductsReport />, protected: true },
  { path: "/inactive-customers-report", element: <InactiveCustomersReport />, protected: true },
  { path: "/job-assignment-system", element: <JobAssignmentSystem />, protected: true },
  { path: "/job-assignment-system-create", element: <JobAssignmentSystemForm />, protected: true },

  // Job Detail
  { path: "/service/:id/:time", element: <JobDetail /> },

  // fallback
  { path: "*", element: <NotFoundPage /> },
];

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ToastContainer position="top-right" />
    <Routes>
      {routesConfig.map(({ path, element, protected: isProtected, onlyForCompany }, index) => {
        const allow =
          (!isProtected || isLoggedIn) &&
          (!onlyForCompany || company === onlyForCompany);

        return (
          <Route
            key={index}
            path={path}
            element={allow ? element : <Navigate to="/login" />}
          />
        );
      })}
    </Routes>
  </BrowserRouter>
);
